import { render, staticRenderFns } from "./PersonalCollection.vue?vue&type=template&id=28c12d82&"
import script from "./PersonalCollection.vue?vue&type=script&lang=ts&"
export * from "./PersonalCollection.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalCollection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PersonalCollection.vue"
export default component.exports